// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-a1b1c0a8]{margin-bottom:0.75rem;display:block;text-align:center}span[data-v-a1b1c0a8]{font-weight:500;color:#111;font-size:17px}.single-title span[data-v-a1b1c0a8]{font-size:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
